import { Navigate } from "react-router-dom";
import { Head } from "vite-react-ssg";
import { t as getFixedT } from "@/i18n";
import { DEFAULT_LANGUAGE, localeUrl } from "@/lib/site";

/**
 * `/` itself isn't a canonical, indexed URL (robots.txt/sitemap.xml point at /ar and /en
 * directly) — it just forwards visitors to the default locale. The prerendered /index.html still
 * needs to work for non-JS clients/crawlers that land on it directly, hence the <meta
 * http-equiv="refresh"> baked in at build time alongside the client-side <Navigate>.
 */
export function RootRedirect() {
  const t = getFixedT(DEFAULT_LANGUAGE);

  return (
    <>
      <Head>
        <html lang={DEFAULT_LANGUAGE} dir="rtl" />
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
        <meta name="robots" content="noindex" />
        {/* Relative target so the redirect stays on the current origin (localhost in dev, the real
            domain in prod) — an absolute URL here would bounce local/staging visitors to prod. */}
        <meta httpEquiv="refresh" content={`0; url=/${DEFAULT_LANGUAGE}`} />
        <link rel="canonical" href={localeUrl(DEFAULT_LANGUAGE)} />
      </Head>
      <Navigate to={`/${DEFAULT_LANGUAGE}`} replace />
    </>
  );
}
